"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyToLocale = exports.localeToCurrency = void 0;
exports.convertSubunitsToMain = convertSubunitsToMain;
exports.getCurrencySymbol = getCurrencySymbol;
exports.standardCurrencyFormat = standardCurrencyFormat;
exports.localeToCurrency = {
    "en-GB": "GBP",
    "en-US": "USD",
};
exports.currencyToLocale = {
    GBP: "en-GB",
    USD: "en-US",
};
function convertSubunitsToMain(value) {
    return value / 100;
}
function getCurrencySymbol(currency, locale = "en-GB") {
    var _a;
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        currencyDisplay: "symbol",
    });
    const parts = formatter.formatToParts(0);
    const symbolPart = parts.find((part) => part.type === "currency");
    return (_a = symbolPart === null || symbolPart === void 0 ? void 0 : symbolPart.value) !== null && _a !== void 0 ? _a : currency;
}
function normalizeInput(input) {
    if (input === null || input === undefined) {
        return null;
    }
    if (typeof input === "number") {
        return input;
    }
    if (input.unit === "subunit") {
        return convertSubunitsToMain(input.value);
    }
    return input.value;
}
function applyRounding(value, targetFractionDigits, mode) {
    const multiplier = Math.pow(10, targetFractionDigits);
    switch (mode) {
        case "floor":
            return Math.floor(value * multiplier) / multiplier;
        case "round":
        default:
            return Math.round(value * multiplier) / multiplier;
    }
}
function removeDecimals(formatted, formatter, value) {
    const parts = formatter.formatToParts(value);
    const decimalPart = parts.find((part) => part.type === "decimal");
    const fractionPart = parts.find((part) => part.type === "fraction");
    if (decimalPart && fractionPart) {
        return parts
            .filter((part) => part.type !== "decimal" && part.type !== "fraction")
            .map((part) => part.value)
            .join("");
    }
    return formatted;
}
function standardCurrencyFormat(input, options) {
    var _a, _b, _c;
    const { currency, locale = "en-GB", decimals = "auto", roundingMode = "round", other, } = options;
    const normalizedValue = normalizeInput(input);
    if (normalizedValue === null) {
        const nullPolicy = (_a = other === null || other === void 0 ? void 0 : other.nullValue) !== null && _a !== void 0 ? _a : "zero";
        if (nullPolicy === "error") {
            throw new Error("Cannot format null or undefined value");
        }
        if (nullPolicy === "custom") {
            return {
                formatted: (_b = other === null || other === void 0 ? void 0 : other.nullValueCustom) !== null && _b !== void 0 ? _b : "—",
                value: 0,
                currency,
                locale,
                symbol: getCurrencySymbol(currency, locale),
            };
        }
    }
    let value = normalizedValue !== null && normalizedValue !== void 0 ? normalizedValue : 0;
    if (value === 0 && (other === null || other === void 0 ? void 0 : other.zeroValue) === "custom") {
        return {
            formatted: (_c = other.zeroValueCustom) !== null && _c !== void 0 ? _c : "0",
            value: 0,
            currency,
            locale,
            symbol: getCurrencySymbol(currency, locale),
        };
    }
    const fractionDigits = decimals === "none" ? 0 : 2;
    value = applyRounding(value, fractionDigits, roundingMode);
    let minFractionDigits = fractionDigits;
    if (decimals === "auto") {
        minFractionDigits = value % 1 !== 0 ? 2 : 0;
    }
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        currencyDisplay: "symbol",
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: fractionDigits,
        signDisplay: "auto",
    });
    let formatted = formatter.format(value);
    if (decimals === "auto" && value % 1 === 0) {
        formatted = removeDecimals(formatted, formatter, value);
    }
    const symbol = getCurrencySymbol(currency, locale);
    return {
        formatted,
        value,
        currency,
        locale,
        symbol,
    };
}
//# sourceMappingURL=currencyFormat.js.map